import { type ReactNode } from 'react';
import type { EventScope } from '../core/EventScope';
import { EventScopeContext } from './EventScopeContext';

interface EventScopeProviderProps {
  scope: EventScope;
  children: ReactNode;
}

export function EventScopeProvider({ scope, children }: EventScopeProviderProps) {
  return (
    <EventScopeContext.Provider value={scope}>
      {children}
    </EventScopeContext.Provider>
  );
}
